var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Row',{staticClass:"py-6 pl-2"},[_c('Icon',{attrs:{"dense":"","icon":"$symbols-circle-info-outline","color":"primary"}}),_c('Link',{staticClass:"text-paragraph-2 ml-1",attrs:{"blank":"","color":"primary","href":"https://www.locaweb.com.br/ajuda/wiki/atualizar-icone-do-site-criador-de-sites/"},domProps:{"textContent":_vm._s(_vm.lc.help)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }